import { render, staticRenderFns } from "./AttendFamilyManagementConference.vue?vue&type=template&id=0232008e"
import script from "./AttendFamilyManagementConference.vue?vue&type=script&lang=ts"
export * from "./AttendFamilyManagementConference.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports